const LightGray = '#f7f7f7';

const DarkGray = 'rgba(194,209,217,0.27)';

export { LightGray, DarkGray };
